package com.appcreator.compose.envfunctions

import coil3.PlatformContext
import com.appcreator.compose.BlueprintConfig

actual fun appVersion(platform: PlatformContext): String = "Web"
actual fun appBuildNumber(platform: PlatformContext): String = "unknown"
actual fun deviceName(): String = "unknown"
actual fun deviceVersion(): String = "unknown"
actual fun platformName(): String = "JavaScript"
actual fun appStoreUrl(platform: PlatformContext, config: BlueprintConfig): String = ""
